<div (click)="update()">
  <input type="checkbox" [checked]="checked"/>
  <label class="ms-auto">Toggle</label>
</div>
